import '../css/app.css';

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import { LaravelReactI18nProvider } from 'laravel-react-i18n';

// const appName = import.meta.env.VITE_APP_NAME || 'Laravel';
const locale = import.meta.env.APP_LOCALE || 'sv';
const fallbackLocale = import.meta.env.APP_FALLBACKLOCALE || 'en';

createInertiaApp({
    // title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./pages/${name}.tsx`,
            import.meta.glob('./pages/**/*.tsx'),
        ),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(
            <LaravelReactI18nProvider
                locale={locale}
                fallbackLocale={fallbackLocale}
                files={import.meta.glob('/lang/*.json', { eager: true })}
            >
                <App {...props} />
            </LaravelReactI18nProvider>
        );
        // root.render(<React.StrictMode><App {...props} /></React.StrictMode>);
    },
    progress: {
        color: '#4B5563',
    },
});
